import { takeEvery, put } from 'redux-saga/effects';
import { LOCATION_CHANGE } from 'react-router-redux';
import { AUTH } from 'STORE/constants';
import queryString from 'query-string';

/**
 * This function is responsible for istening to the route changes
 * and handle with necessary updates in the store.
 * @param {Route location object} param
 */
export function* watchRouteChange({ payload }) {
  const searchParams = queryString.parse(payload.search);

  if (payload.pathname.includes('/sign-in')) {
    if (typeof searchParams.token === 'string') {
      return yield put({ type: AUTH.SIGNIN.COMPLETE, token: searchParams.token });
    }
    if (payload.pathname.includes('invalid-email')) {
      return yield put({ type: AUTH.SIGNIN.ACCOUNT_INVALID });
    }
  }
}

export default function* rootSagas() {
  yield takeEvery(LOCATION_CHANGE, watchRouteChange);
}



// WEBPACK FOOTER //
// ./src/store/sagas/route.sagas.js